<template>
  <v-container>
    <v-row class="fill-height" align-content="center" justify="center">
      <div class="mx-auto mt-4">
        <GoogleLogin
          :params="googleSignInParams"
          :renderParams="googleSignInRenderParams"
          :onSuccess="onGoogleLoginSuccess"
          :onFailure="onGoogleLoginFailure"
        >
          Sign in with Google
        </GoogleLogin>

        <v-progress-linear
          v-show="showLoader"
          class="mx-auto mt-2"
          color="green"
          max-width="100px"
          indeterminate
        ></v-progress-linear>
      </div>
    </v-row>
     <v-snackbar
        app
        v-model="snackbar_show"
        type="warning"
        width="100%"
        color="info"
        vertical="vertical"
        >{{ snackbar_text }}</v-snackbar>
  </v-container>
</template>
<style>
.g-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: #3c82f7;
  color: #fff;
  box-shadow: 0 3px 0 #0f69ff;
}
</style>

<script>
import mj_axios from "@/mj_axios.js";
import store from "@/store.js";
import GoogleLogin from "vue-google-login";

export default {
  name: "MjGoogleLoginButton",

  components: { GoogleLogin },
  created() {},
  data: () => ({
    snackbar_show:false,
    snackbar_text:'',
    googleSignInParams: {
      clientId:
        "480032247899-9hl59rus735aclrljcmakan30fsut30g.apps.googleusercontent.com",
    },
    googleSignInRenderParams: {
      width: 250,
      height: 50,
      longtitle: true,
    },
    showLoader: false,
  }),
  methods: {
    onGoogleLoginSuccess(googleUser) {
      this.showLoader = true;
      // `googleUser` is the GoogleUser object that represents the just-signed-in user.
      // See https://developers.google.com/identity/sign-in/web/reference#users
      // const profile = googleUser.getBasicProfile(); // etc etc

      mj_axios
        .get(
          "/api/user/google/verify_token_and_login/" +
            googleUser.getAuthResponse(true).access_token
        )
        .then((response) => {
          const token_obj = response.data;
          store.commit("login_success", token_obj);
          this.$router.replace("/menu");
        })
        .catch((error) => {

            this.snackbar_show = true;
            this.snackbar_text = `Errore Nel Google Login ${error}`;

        })
        .then(() => {
          this.showLoader = false;
        });
    },
    onGoogleLoginFailure(error) {
      // alert(error);
  this.snackbar_show = true;
  this.snackbar_text = `Errore Nel Google Login ${error}`;
      this.showLoader = false;
    },
  },
};
</script>
